export var compareArrays = function (current, updated) {
    return (current.length === updated.length) &&
        (current.every(function (id) { return updated.indexOf(id) > -1; }));
};
//# sourceMappingURL=compareArrays.js.map